import { Counter, MyleCounterStyle } from "./Counters";
import { ICounters } from "./ICounters";

/**
 * Represents a set of document's counters.
 * Implements the ICounters interface to track unread results.
 */
class DocumentsCounters implements ICounters {
    /** The number of unapproved documents. */
    private readonly unapprovedDocuments: number;

    /** The number of new faxes that have not yet been indexed. */
    private readonly notIndexedNewFaxes: number;

    /** The number of urgent documents. */
    private readonly urgentDocuments: number;

    /** The number of prioritized faxes */
    private readonly prioritizedFaxes: number;

    /**
     * @param {number} unapprovedDocuments - The number of unapproved documents.
     * @param {number} notIndexedNewFaxes - The number of new faxes that have not yet been indexed.
     * @param {number} urgentDocuments - The number of urgent documents.
     */
    constructor(unapprovedDocuments: number, notIndexedNewFaxes: number, urgentDocuments: number, prioritizedFaxes: number) {
        this.unapprovedDocuments = unapprovedDocuments;
        this.notIndexedNewFaxes = notIndexedNewFaxes;
        this.urgentDocuments = urgentDocuments;
        this.prioritizedFaxes = prioritizedFaxes;
    }

    /**
     * Retrieves an array of Counter objects representing each type of documents counter.
     * @returns {Counter[]} An array of counters with their respective labels and statuses.
     */
    public getCounters(): Counter[] {
        return [
            new Counter(this.unapprovedDocuments, "Tooltip_UnapprovedDocuments", MyleCounterStyle.blueCircleWithBackground),
            new Counter(this.notIndexedNewFaxes, "Tooltip_NotIndexedNewFaxes", MyleCounterStyle.blueCircleNoBackground),
            new Counter(this.urgentDocuments, "Tooltip_UrgentDocuments", MyleCounterStyle.redCircleWithBackground),
            new Counter(this.prioritizedFaxes, "Tooltip_PrioritizedFaxes", MyleCounterStyle.redCircleNoBackground)
        ];
    }

    /**
     * Determines if the counter can be displayed.
     * @returns {boolean} True if the counter can be displayed, otherwise false.
     */
    public showCounters(): boolean {
        return this.unapprovedDocuments !== 0
        || this.notIndexedNewFaxes !== 0
        || this.unapprovedDocuments !== 0
        || this.prioritizedFaxes !== 0;
    }
}

export { DocumentsCounters };
